import * as React from "react";

export default function Container({
  className = "",
  children,
}: React.PropsWithChildren<{ className?: string }>) {
  return (
    <div className={`mx-auto w-full max-w-full px-4 sm:px-6 lg:px-8 lg:max-w-[1320px] box-border ${className}`}>
      {children}
    </div>
  );
}
